module.exports = __webpack_public_path__ + "static/media/ios.043aac9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios.svg
// module id = 231
// module chunks = 0